<template>
  <div class="menu-wrapper">

    <!-- 当只有一个子菜单且不隐藏时，直接展示菜单项 -->
    <template v-if="!item.hidden && hasOneShowingChildren(item.children) && !isNest">
      <template v-for="child in item.children" v-if="!child.hidden">
        <!-- 支持外链功能 -->
        <a v-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
          <el-menu-item :index="child.path">
            <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </a>
        <router-link v-else v-debounce :to="item.path + '/' + child.path" :key="child.name" @click.native.capture="handleMenuClick($event, item.path + '/' + child.path)">
          <el-menu-item :index="item.path + '/' + child.path">
            <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </router-link>
      </template>
    </template>

    <!-- 多个子菜单时展示目录 -->
    <el-submenu
      v-else-if="!item.hidden"
      :index="item.name||item.path" :key="item.name"
      @click.native.capture="preventParentMenuClick"
    >
      <template slot="title">
        <svg-icon v-if="item.meta&&item.meta.icon&&isCollapse" :icon-class="item.meta.icon"></svg-icon>
        <span v-if="item.meta&&item.meta.title" slot="title">{{ $t(item.meta.title) }}</span>
      </template>

      <template v-for="child in item.children" v-if="!child.hidden">
        <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]"
                      :item="child" :is-collapse="isCollapse" :key="child.path"></sidebar-item>
        <!-- 支持外链功能 -->
        <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
          <el-menu-item :index="item.path+'/'+child.path">
             <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </a>
        <router-link v-else v-debounce :to="item.path+'/'+child.path" :key="child.name" @click.native.capture="handleMenuClick($event, item.path + '/' + child.path)">
          <el-menu-item :index="item.path+'/'+child.path">
             <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{ $t(child.meta.title) }}</span>
          </el-menu-item>
        </router-link>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import {navigateFromMenu} from '@/utils/pageNavigation'

export default {
  name: 'SidebarItem',
  props: {
    item: {
      required: true,
      type: Object
    },
    isNest: {
      type: Boolean,
      default: false
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMenuClick(event, location) {
      return navigateFromMenu(this.$router, this.$store, location, event)
    },
    preventParentMenuClick(event) {
      if (event.target.closest('.el-submenu__title')) {
        event.stopPropagation()
      }
    },
    hasOneShowingChildren(children) {
      // if (!children) {
      //   return false
      // }
      // const showingChildren = children.filter(item => {
      //   return !item.hidden
      // })
      // return showingChildren.length === 1
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue